import React, { useEffect, useState, useRef, useMemo, useCallback } from "react";
import SearchIcon from "assets/icons/search-icon.png";
import ResendIcon from "assets/svgIcons/ResendIcon";
import ClubToCarMsgIcon from "assets/svgIcons/ClubToCarMsg";
import CarToClubMsgIcon from "assets/svgIcons/CarToClubMsg";
import CarToMarshalCarMsg from "assets/svgIcons/CarToMarshalMsg";
import CarToAllMsg from "assets/svgIcons/CarToAllMsg";
import ExclamationMarkIcon from "assets/svgIcons/ExclamationMarkIconWithBorder";
import FilterFlagIcon from "assets/svgIcons/FlagIconWithBorder";
import ExclamationMarkTrangel from "assets/svgIcons/ExclamationMarkTrangelIconWithBorder";
import BatteryIcon from "assets/svgIcons/BatteryIconWithBorder";
import MarshalsCarIcon from "assets/svgIcons/CarType/Marshals";
import TimeIcon from "assets/svgIcons/TimeIcon";
import HomeIcon from "assets/svgIcons/HomeIcon";
import StarIcon from "assets/svgIcons/StarIcon";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import IconButton from "@mui/material/IconButton";
import ThreeDotIcon from "assets/svgIcons/ThreeDotsIcon";
import { getMessagesHistory } from "redux/reduxToolkitServices/_commonApiCalls/api";
import {
  HistoryContainer,
  Header,
  SearchWrapper,
  HistoryTableInnerSection,
} from "pages/Messages/History/HistoryStyled";
import { useDispatch, useSelector } from "react-redux";
import {
  COMMON_SERVICES,
  headersConfigData,
} from "redux/reduxToolkitServices/_commonServices/commonServices";
import { TextField, Tooltip } from "@mui/material";
import { Stack } from "@mui/system";
import moment from "moment";
import { useHookstate } from "@hookstate/core";
import {
  SITEID_GLOBAL_STATE,
  UPDATED_CAR_DATA_STATE,
} from "../../../globalStore/globalStore";
import {
  TableContainer,
  BodyWrapper,
  DateRangePickerWrapper,
  MobileHeader,
} from "assets/css/globle";
import { useTranslation } from "react-i18next";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import WarningIcon from "@mui/icons-material/Warning";
import ErrorIcon from "@mui/icons-material/Error";
import Battery0BarIcon from "@mui/icons-material/Battery0Bar";
import SportsScoreIcon from "@mui/icons-material/SportsScore";
import {
  featureKey,
  isUserAdmin,
  isUserSupport,
  isUserAdminOrSupport,
  getFeatureSetOption,
  getFeaturesList,
} from "constant";
import MembercarIcon from "assets/svgIcons/CarType/MembercarIcon";
import DiagnosticsIcon from "assets/svgIcons/MsgNotificationIcons/diagnosticsIcon";
import { validateCarType } from "_helperFunctions/validateCarType";
import { isVdu3Or4Car } from "_helperFunctions/isVdu3Or4Car";
import TodayDateActionBar from "commonComponents/Calendar/todayDateActionBar";
import { DataGridPro } from "@mui/x-data-grid-pro";

export const History = () => {
  const { t } = useTranslation();

  const outerW = useRef(null);
  const innerW = useRef(null);
  const { updatedCarData } = useHookstate(UPDATED_CAR_DATA_STATE);
  const { siteId } = useHookstate(SITEID_GLOBAL_STATE);

  const dispatch = useDispatch();

  const { siteSettingsData, getUserRole } = useSelector((state) => state.commonReducers) || [];

  const enableMemberCar = isUserAdmin(getUserRole && getUserRole?.Role) || isUserSupport(getUserRole && getUserRole?.Role) || !getFeatureSetOption(siteSettingsData?.Features, getFeaturesList().member_cars);

  const isAdminOrSupport =
    (getUserRole !== undefined && getUserRole !== null) &&
    isUserAdminOrSupport(getUserRole && getUserRole?.Role);

  const HISTORY_FILTERS_KEY = "messageHistoryFilters";

  const getDefaultFilters = () => ({
    showToCar: true,
    showFromCar: true,
    showForwarded: true,
    showBroadcast: true,
    showDiagnostics: false,
    showBatteryNotifications: false,
    showMaxHolesNotifications: false,
    showAZNotifications: false,
    showCritFaultNotifications: false,
    showMemberCars: enableMemberCar,
  });

  const getCachedFilters = () => {
    try {
      const stored = localStorage.getItem(HISTORY_FILTERS_KEY);
      if (stored) {
        const parsed = JSON.parse(stored);
        return { ...getDefaultFilters(), ...parsed };
      }
    } catch (e) {
      // ignore parse errors
    }
    return getDefaultFilters();
  };

  const cachedFilters = getCachedFilters();

  const [threeDotState, setThreeDotState] = useState(false);
  const [searchInputValue, setSearchInputValue] = useState("");
  const [showToCar, setShowToCar] = useState(cachedFilters.showToCar);
  const [showFromCar, setShowFromCar] = useState(cachedFilters.showFromCar);
  const [showForwarded, setShowForwarded] = useState(cachedFilters.showForwarded);
  const [showBroadcast, setShowBroadcast] = useState(cachedFilters.showBroadcast);
  const [showDiagnostics, setShowDiagnostics] = useState(cachedFilters.showDiagnostics);
  const [showMore, setShowMore] = useState({});
  const [showBatteryNotifications, setShowBatteryNotifications] = useState(cachedFilters.showBatteryNotifications);
  const [showMaxHolesNotifications, setShowMaxHolesNotifications] = useState(cachedFilters.showMaxHolesNotifications);
  const [showAZNotifications, setShowAZNotifications] = useState(cachedFilters.showAZNotifications);
  const [showCritFaultNotifications, setShowCritFaultNotifications] = useState(cachedFilters.showCritFaultNotifications);
  const [showMemberCars, setShowMemberCars] = useState(cachedFilters.showMemberCars);
  const [messagesHistoryDataState, setMessagesHistoryData] = useState([]);
  const [messageStatus, setMessageStatus] = useState(false);
  const [messageTextFilter, setMessageTextFilter] = useState("");
  const [startDate, setStartDate] = useState(localStorage.getItem("startDate") ? new Date(localStorage.getItem("startDate")) : new Date());
  const [endDate, setEndDate] = useState(localStorage.getItem("endDate") ? new Date(localStorage.getItem("endDate")) : new Date());

  const messageTypes = useMemo(
    () => ({
      Text: 0,
      ActionZone: 1,
      CriticalFault: 2,
      LowBattery: 3,
      MaxHoles: 4,
    }),
    []
  );

  const messageResponse = useMemo(
    () => ({
      None: 0,
      Ok: 1,
      Yes: 2,
      No: 3,
    }),
    []
  );

  const decodeHtml = useCallback((html) => {
    const txt = document.createElement("textarea");
    txt.innerHTML = html || "";
    return txt.value;
  }, []);

  const messageResponseText = useCallback(
    (response) => {
      switch (response) {
        case messageResponse.None:
          return "-";
        case messageResponse.Ok:
          return "Ok";
        case messageResponse.Yes:
          return "Yes";
        case messageResponse.No:
          return "No";
        default:
          return "?";
      }
    },
    [messageResponse]
  );

  useEffect(() => {
    const storedStart = localStorage.getItem("startDate");
    const storedEnd = localStorage.getItem("endDate");
    const today = new Date();

    if (!storedStart) {
      localStorage.setItem("startDate", today);
      setStartDate(today);
    }

    if (!storedEnd) {
      localStorage.setItem("endDate", today);
      setEndDate(today);
    }

    const handleUnload = () => {
      localStorage.removeItem("startDate");
      localStorage.removeItem("endDate");
    };

    window.addEventListener("beforeunload", handleUnload);

    return () => {
      window.removeEventListener("beforeunload", handleUnload);
    };
  }, []);

  useEffect(() => {
    if (!getUserRole || getUserRole.Role === undefined) return;
    if (!isAdminOrSupport && showDiagnostics) {
      setShowDiagnostics(false);
    }
  }, [getUserRole, isAdminOrSupport, showDiagnostics]);

  useEffect(() => {
    localStorage.setItem(
      HISTORY_FILTERS_KEY,
      JSON.stringify({
        showToCar,
        showFromCar,
        showForwarded,
        showBroadcast,
        showDiagnostics,
        showBatteryNotifications,
        showMaxHolesNotifications,
        showAZNotifications,
        showCritFaultNotifications,
        showMemberCars,
      })
    );
  }, [
    showToCar,
    showFromCar,
    showForwarded,
    showBroadcast,
    showDiagnostics,
    showBatteryNotifications,
    showMaxHolesNotifications,
    showAZNotifications,
    showCritFaultNotifications,
    showMemberCars,
  ]);

  const refresh = useCallback(async () => {
    let tempStartDate = moment(startDate)
      .utcOffset(-siteSettingsData?.TimeZoneOffset)
      .startOf("day");

    let tempEndDate = moment(endDate)
      .add(1, "days")
      .utcOffset(-siteSettingsData?.TimeZoneOffset)
      .startOf("day");

    setMessageStatus(true);

    try {
      const res = await getMessagesHistory(
        siteId.get(),
        tempStartDate.format(),
        tempEndDate.format(),
        headersConfigData
      );

      const resJ = await res.json();
      setMessagesHistoryData(Array.isArray(resJ) ? resJ : []);
    } finally {
      setMessageStatus(false);
    }
  }, [
    startDate,
    endDate,
    siteSettingsData?.TimeZoneOffset,
    siteId,
  ]);

  useEffect(() => {
    dispatch(COMMON_SERVICES.getSiteSettingsServices(siteId.get()));
    refresh();
  }, [siteId.get()]);

  useEffect(() => {
    dispatch(COMMON_SERVICES.getUserNameAndRoles());
  }, []);

  useEffect(() => {
    if (startDate > endDate) {
      setEndDate(startDate);
    }
  }, [startDate, endDate]);

  useEffect(() => {
    if (startDate > endDate) {
      setStartDate(endDate);
    }
  }, [endDate, startDate]);

  useEffect(() => {
    refresh();
  }, [
    showDiagnostics,
    showBatteryNotifications,
    showMaxHolesNotifications,
    showAZNotifications,
    showCritFaultNotifications,
  ]);

  const messagesList = useMemo(() => {
    if (!Array.isArray(messagesHistoryDataState)) {
      return [];
    }

    const searchValue = searchInputValue.trim().toLowerCase();

    const list = messagesHistoryDataState
      .filter((item) => {
        if (!searchValue) {
          return true;
        }

        return String(item?.CarNum || "")
          .toLowerCase()
          .includes(searchValue);
      })
      .map((item) => ({
        ...item,
        id: item.Id,
        received: moment(item.Created).unix(),
        lastUpdated: item.LastUpdated,
        car: item.CarNum,
        text: item.Text,
        response: item.Response,
        hole: item.Hole,
        status: item.Delivered,
        sentBy: item.SentBy,
      }));

    const result = [];

    for (let i = 0; i < list.length; i++) {
      const current = {
        ...list[i],
        IsBroadcast: false,
        IsDuplicate: false,
      };

      const text = current?.Text || "";

      if (text.indexOf("z1lk3r") >= 0 || text.indexOf("v1s*g3") >= 0) {
        current.IsDiagnostic = true;
        current.Text = text.replace("z1lk3r -", "").replace("v1s*g3 -", "");
        current.icon = "fa-stethoscope";
      } else {
        current.IsDiagnostic = false;
        current.icon = "";
      }

      current.IsSoftwareUpdate = text.indexOf("Download SW") >= 0;

      result.push(current);
    }

    for (let i = 1; i < result.length; i++) {
      const a = result[i - 1];
      const b = result[i];

      if (
        b.ToCar &&
        a.ToCar &&
        a.CarNum !== b.CarNum &&
        a.Text === b.Text
      ) {
        const ca = moment(a.Created);
        const cb = moment(b.Created);

        if (ca.add(5, "s").isAfter(cb)) {
          if (!a.IsDuplicate) {
            a.IsBroadcast = true;
          }

          b.IsDuplicate = true;
        }
      }
    }

    return result.sort((a, b) => {
      if (a.created > b.created) return 1;
      if (a.created < b.created) return -1;
      return 0;
    });
  }, [messagesHistoryDataState, searchInputValue]);

  const filteredData = useMemo(() => {
    const txt = messageTextFilter.trim().toUpperCase();
    const filtered = [];
    let filteredCount = 0;

    // Cache member-car lookup so validateCarType is only called once per car.
    const carData = updatedCarData.get();
    const memberCarCache = new Map();

    const isMemberCar = (carNum) => {
      if (!carNum) {
        return false;
      }

      if (!memberCarCache.has(carNum)) {
        memberCarCache.set(
          carNum,
          validateCarType(carNum, carData)
        );
      }

      return memberCarCache.get(carNum);
    };

    for (let i = 0; i < messagesList.length; i++) {
      const msg = messagesList[i];

      // SW update messages are Admin/Support only - silently skip for other roles
      // (not counted in filteredCount, so lower roles won't know they were filtered)
      if (!isAdminOrSupport && msg?.IsSoftwareUpdate) {
        continue;
      }

      if (
        !isAdminOrSupport &&
        msg?.MessageType === messageTypes.CriticalFault &&
        isVdu3Or4Car(msg?.CarNum, carData)
      ) {
        continue;
      }

      // Only do the member-car lookup when it is actually needed.
      const memberCar =
        showMemberCars && !msg?.IsBroadcast && !msg?.IsDuplicate
          ? isMemberCar(msg?.CarNum)
          : false;

      let passed = true;

      // Hiding messages from negative car numbers for non-admin/support users
      if (!isAdminOrSupport && Number(msg?.CarNum) < 0) {
        continue;
      }

      if (showMemberCars && !msg?.IsBroadcast && !msg?.IsDuplicate && !memberCar) {
        passed = false;
      }

      if (!showMaxHolesNotifications && msg?.MessageType === messageTypes.MaxHoles) {
        passed = false;
      }

      if (
        !(siteSettingsData?.Features?.indexOf(featureKey.power) >= 0) &&
        !showBatteryNotifications &&
        msg?.MessageType === messageTypes.LowBattery
      ) {
        passed = false;
      }

      if (!showAZNotifications && msg?.MessageType === messageTypes.ActionZone) {
        passed = false;
      }

      if (
        !(siteSettingsData?.Features?.indexOf(featureKey.power) >= 0) &&
        !showCritFaultNotifications &&
        msg?.MessageType === messageTypes.CriticalFault
      ) {
        passed = false;
      }

      if (!showDiagnostics && msg?.IsDiagnostic) {
        passed = false;
      }

      if (txt && !msg?.Text?.toUpperCase().includes(txt)) {
        passed = false;
      }

      if (showBroadcast && msg?.IsDuplicate) {
        passed = false;
      }

      if (passed) {
        if (
          !(
            (showToCar && msg?.ToCar && !msg?.ForwardedFrom) ||
            (showForwarded && msg?.ForwardedFrom) ||
            (showFromCar && !msg?.ToCar)
          )
        ) {
          passed = false;
        }
      }

      if (passed) {
        filtered.push(msg);
      } else {
        const isHiddenBySearch = txt && !msg?.Text?.toUpperCase().includes(txt);

        if (!isHiddenBySearch) {
          filteredCount++;
        }
      }
    }

    return {
      rows: filtered,
      filteredCount,
    };
  }, [
    messagesList,
    messageTextFilter,
    enableMemberCar,
    isAdminOrSupport,
    showMemberCars,
    showMaxHolesNotifications,
    showBatteryNotifications,
    showAZNotifications,
    showCritFaultNotifications,
    showDiagnostics,
    showBroadcast,
    showToCar,
    showForwarded,
    showFromCar,
    siteSettingsData?.Features,
    updatedCarData,
    messageTypes,
  ]);

  const sentString = useCallback(
    (message) => {
      const sent = moment.utc(message.Created);

      if (siteSettingsData) {
        sent.utcOffset(-siteSettingsData?.TimeZoneOffset);
      }

      return sent.format("DD-MMM-YYYY hh:mm a");
    },
    [siteSettingsData]
  );

  const showToCars = useCallback(
    (msg) => {
      return showToCar && msg.ToCar && !msg.ForwardedFrom;
    },
    [showToCar]
  );

  const showForward = useCallback(
    (msg) => {
      return showForwarded && msg.ForwardedFrom;
    },
    [showForwarded]
  );

  const showFromCars = useCallback(
    (msg) => {
      return showFromCar && !msg.ToCar;
    },
    [showFromCar]
  );

  const showBroadcastMessages = useCallback(
    (msg) => {
      return showBroadcast && msg.IsDuplicate;
    },
    [showBroadcast]
  );

  const deliveredString = useCallback(
    (message) => {
      if (message.ToCar) {
        if (message.Delivered) {
          return t("Delivered");
        }

        const now = moment.utc();

        if (now.isAfter(moment.utc(message.Expires))) {
          return t("Failed");
        }

        return t("Pending");
      }

      return "-";
    },
    [t]
  );

  const responseString = useCallback(
    (message) => {
      if (!message?.ToCar) {
        return messageResponseText(message?.Response);
      }

      return "";
    },
    [messageResponseText]
  );

  const holeString = useCallback(
    (message) => {
      if (!message?.ToCar) {
        if (
          siteSettingsData?.Courses?.length > 1 &&
          message?.Course &&
          message?.Hole
        ) {
          return message?.Course + message?.Hole.toString();
        }

        if (message?.Hole) {
          return message?.Hole.toString();
        }

        return "-";
      }

      return "";
    },
    [siteSettingsData]
  );

  const showAsterisk = useCallback(
    (msg) => {
      if (!msg?.IsBroadcast && !showBroadcast) {
        return null;
      }

      if (msg?.IsBroadcast && showBroadcast) {
        return <StarIcon style={{ marginTop: 5 }} />;
      }

      return null;
    },
    [showBroadcast]
  );

  const renderMessageTypeIcon = useCallback((messageType) => {
    if (messageType === 1) {
      return <WarningIcon />;
    }

    if (messageType === 2) {
      return <ErrorIcon />;
    }

    if (messageType === 3) {
      return <Battery0BarIcon />;
    }

    if (messageType === 4) {
      return <SportsScoreIcon />;
    }

    return null;
  }, []);

  const columns = useMemo(
    () => [
      {
        field: "received",
        headerName: t("Sent/Received"),
        headerClassName: "received-column display",
        minWidth: 200,
        align: "left",
        flex: 1,
        renderCell: (params) => {
          return (
            <div className="super-time-theme--cell received-column">
              <TimeIcon color="#0009" width={13} height={13} />
              <span>{sentString(params?.row)}</span>
            </div>
          );
        },
      },
      {
        field: "car",
        headerName: t("Car"),
        headerClassName: "lastcolumnSeparator",
        width: 130,
        renderCell: (params) => {
          return (
            <div style={{ display: "flex", gap: "5px" }} className="cars-cell">
              <span>
                {showForward(params?.row) ? (
                  <p>
                    {params?.row?.ForwardedFrom}{" "}
                    <ArrowRightIcon style={{ color: "#a75c00" }} />{" "}
                    <MarshalsCarIcon />
                  </p>
                ) : (
                  ""
                )}

                {showToCars(params?.row) ? (
                  <span style={{ marginTop: 5 }}>
                    <span style={{ marginTop: 10 }}>
                      <HomeIcon width={12} height={12} color="blue" />
                    </span>
                    <ArrowRightIcon style={{ color: "blue" }} />
                  </span>
                ) : (
                  ""
                )}
              </span>

              <span style={{ marginTop: 8 }}>
                {params?.row?.CarNum}
              </span>

              <span>
                {showFromCars(params?.row) ? (
                  <span style={{ marginTop: 5 }}>
                    <ArrowRightIcon style={{ color: "#a75c00" }} />
                    <HomeIcon
                      color="#a75c00"
                      style={{ marginTop: 10 }}
                    />
                  </span>
                ) : (
                  ""
                )}

                {showBroadcastMessages(params?.row) ? (
                  <CarToAllMsg style={{ marginTop: 5 }} />
                ) : (
                  ""
                )}

                <span style={{ marginTop: 10 }}>
                  {showAsterisk(params?.row)}
                </span>
              </span>
            </div>
          );
        },
      },
      {
        field: "text",
        headerName: t("Text"),
        minWidth: 220,
        headerClassName: "lastcolumnSeparator flex-1 for-show-more",
        cellClassName: "word-wrap",
        flex: 3,
        renderCell: (params) => {
          const isExpanded = !!showMore[params.row.Id];

          return (
            <div
              className={
                !isExpanded
                  ? "text-cell-inner-data dot-add"
                  : "text-cell-inner-data"
              }
            >
              <div
                ref={outerW}
                className={
                  !isExpanded
                    ? "inner-div inner-dot-add"
                    : "inner-div"
                }
              >
                <p ref={innerW}>
                  <div style={{ marginTop: -30 }}>{renderMessageTypeIcon(params?.row?.MessageType)}</div>
                  {decodeHtml(params?.row?.Text)}

                  {showForward(params?.row) ? (
                    <span
                      style={{
                        display: "block",
                        fontStyle: "italic",
                        color: "#808080",
                      }}
                    >
                      {t("Forwarded_to_marshals_from_car")}
                      {` ${params?.row?.ForwardedFrom}`}
                    </span>
                  ) : (
                    ""
                  )}
                </p>

                {params.row.Text.length > 15 ? (
                  <button
                    className="show-more-btn"
                    onClick={() => {
                      setShowMore((prev) => ({
                        ...prev,
                        [params.row.Id]: !prev[params.row.Id],
                      }));
                    }}
                  >
                    {isExpanded ? "Show less" : "Show more"}
                  </button>
                ) : (
                  ""
                )}
              </div>
            </div>
          );
        },
      },
      {
        field: "response",
        headerName: t("Response"),
        width: 150,
        headerClassName: "lastcolumnSeparator",
        renderCell: (params) => {
          return (
            <div style={{ display: "grid" }}>
              <span>{responseString(params?.row)}</span>
            </div>
          );
        },
      },
      {
        field: "hole",
        headerName: t("Hole"),
        width: 150,
        headerClassName: "lastcolumnSeparator",
        cellClassName: "word-wrap",
        renderCell: (params) => {
          return (
            <div style={{ display: "grid" }}>
              <span>{holeString(params?.row)}</span>
            </div>
          );
        },
      },
      {
        field: "status",
        headerName: t("Status"),
        type: "letter",
        width: 150,
        headerClassName: "lastcolumnSeparator",
        renderCell: (params) => {
          return (
            <div style={{ display: "grid" }}>
              <span>{deliveredString(params?.row)}</span>
            </div>
          );
        },
      },
      {
        field: "sentBy",
        headerName: t("Sent_by"),
        type: "letter",
        minWidth: 200,
        headerClassName: "lastcolumnSeparator",
        renderCell: (params) => {
          return (
            <div style={{ display: "grid" }}>
              <span>{params?.row.SentBy}</span>
            </div>
          );
        },
      },
    ],
    [
      t,
      sentString,
      showForward,
      showToCars,
      showFromCars,
      showBroadcastMessages,
      showAsterisk,
      showMore,
      renderMessageTypeIcon,
      decodeHtml,
      responseString,
      holeString,
      deliveredString,
    ]
  );

  const getRowHeight = useCallback((params) => {
    const content = `${params?.model?.text || ""}`;
    const course = `${params?.model?.Course || ""}`;

    return content.length > 90 || course.length > 30 ? 100 : 50;
  }, []);

  const dateChecker = useCallback(
    (newValue, dateDetector) => {
      if (newValue && newValue.format() !== "Invalid Date") {
        const newDate = new Date(newValue);

        if (dateDetector === "startDate") {
          const currentEndDate = new Date(endDate);

          const newDateValue = new Date(
            newDate.getTime() - newDate.getTimezoneOffset() * 60000
          )
            .toISOString()
            .split("T")[0];

          const endDateValue = new Date(
            currentEndDate.getTime() -
            currentEndDate.getTimezoneOffset() * 60000
          )
            .toISOString()
            .split("T")[0];

          if (newDateValue > endDateValue) {
            localStorage.setItem("startDate", newDate);
            localStorage.setItem("endDate", newDate);
            setStartDate(newDate);
            setEndDate(newDate);
          } else {
            localStorage.setItem("startDate", newDate);
            setStartDate(newDate);
          }
        } else {
          const currentStartDate = new Date(startDate);

          const startDateValue = new Date(
            currentStartDate.getTime() -
            currentStartDate.getTimezoneOffset() * 60000
          )
            .toISOString()
            .split("T")[0];

          const newDateValue = new Date(
            newDate.getTime() - newDate.getTimezoneOffset() * 60000
          )
            .toISOString()
            .split("T")[0];

          if (startDateValue > newDateValue) {
            localStorage.setItem("startDate", newDate);
            localStorage.setItem("endDate", newDate);
            setStartDate(newDate);
            setEndDate(newDate);
          } else {
            localStorage.setItem("endDate", newDate);
            setEndDate(newDate);
          }
        }
      } else if (newValue === null) {
        if (dateDetector === "startDate") {
          const storedDate = localStorage.getItem("startDate");

          if (storedDate) {
            setStartDate(new Date(storedDate));
          }
        } else {
          const storedDate = localStorage.getItem("endDate");

          if (storedDate) {
            setEndDate(new Date(storedDate));
          }
        }
      }
    },
    [startDate, endDate]
  );

  const dataGridStyle = useMemo(
    () => ({
      "& .MuiDataGrid-row": {
        minHeight: 35,
        boxShadow: "0px 4px 15px rgba(0,0,0,0.1)",
        "&:hover": {
          backgroundColor: "#f1f1f1",
        },
      },
      "& .MuiDataGrid-cell": {
        fontSize: "12px",
        color: "var(--text-primary)",
        padding: "2px 8px",
        textAlign: "center",
        outline: "none",
        "&:focus": {
          outline: "none",
        },
      },
      "& .MuiDataGrid-filler--pinnedLeft": {
        width: "0 !important",
      },
    }),
    []
  );

  return (
    <HistoryContainer>
      <Header className="display">
        <Tooltip title={t("Filter_by_car_number")}>
          <div>
            <SearchWrapper>
              <input
                type="text"
                placeholder="Car no."
                value={searchInputValue}
                onChange={(e) => setSearchInputValue(e.target.value)}
              />
              <img src={SearchIcon} alt="search-icon" />
            </SearchWrapper>
          </div>
        </Tooltip>

        <DateRangePickerWrapper>
          <p className="label">{t("Start")}</p>

          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              inputFormat="DD-MMM-YYYY"
              selectsEnd
              value={startDate}
              className="test"
              onChange={(newValue) => { dateChecker(newValue, "startDate"); }}
              renderInput={(params) => <TextField {...params} />}
              components={{
                ActionBar: (props) => (
                  <TodayDateActionBar
                    {...props}
                    onToday={() => {
                      const today = moment().startOf("day");
                      dateChecker(today, "startDate");
                      props.onAccept?.();
                      props.onClose?.();
                    }}
                  />
                ),
              }}
            />
          </LocalizationProvider>

          <p className="label">{t("End")}</p>

          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              className="test"
              inputFormat="DD-MMM-YYYY"
              value={endDate}
              onChange={(newValue) => { dateChecker(newValue, "endDate"); }}
              renderInput={(params) => <TextField {...params} />}
              components={{
                ActionBar: (props) => (
                  <TodayDateActionBar
                    {...props}
                    onToday={() => {
                      const today = moment().startOf("day");
                      dateChecker(today, "endDate");
                      props.onAccept?.();
                      props.onClose?.();
                    }}
                  />
                ),
              }}
            />
          </LocalizationProvider>
        </DateRangePickerWrapper>

        <Tooltip title={t("Refresh")}>
          <div>
            <button className="refresh-btn" onClick={refresh}>
              <ResendIcon className={messageStatus ? "rotate" : ""} />
            </button>
          </div>
        </Tooltip>

        <div>
          <Tooltip title={t("Show_messages_to_cars")}>
            <div>
              <ClubToCarMsgIcon
                onClick={() => setShowToCar(!showToCar)}
                color={showToCar ? "var(--theme-background)" : "var(--input-background)"}
              />
            </div>
          </Tooltip>

          <Tooltip title={t("Show_messages_from_cars")}>
            <div>
              <CarToClubMsgIcon
                onClick={() => setShowFromCar(!showFromCar)}
                color={showFromCar ? "var(--theme-background)" : "var(--input-background)"}
              />
            </div>
          </Tooltip>

          <Tooltip title={t("Show_messages_forwarded_to_marshal(s)")}>
            <div>
              <CarToMarshalCarMsg
                onClick={() => setShowForwarded(!showForwarded)}
                color={showForwarded ? "var(--theme-background)" : "var(--input-background)"}
              />
            </div>
          </Tooltip>
        </div>

        <div>
          <Tooltip title={t("Group_broadcast_messages_together")}>
            <div>
              <CarToAllMsg
                onClick={() => setShowBroadcast(!showBroadcast)}
                color={showBroadcast ? "var(--theme-background)" : "var(--input-background)"}
              />
            </div>
          </Tooltip>
        </div>

        <div>
          <Tooltip title={t("Show_Action_Zone_notifications")}>
            <div>
              <ExclamationMarkTrangel
                onClick={() => setShowAZNotifications(!showAZNotifications)}
                color={showAZNotifications ? "var(--theme-background)" : "none"}
                fill="var(--input-background)"
                stroke="var(--input-background)"
              />
            </div>
          </Tooltip>

          <Tooltip title={t("Show_Car_Fault_notifications")}>
            <div>
              <ExclamationMarkIcon
                onClick={() => setShowCritFaultNotifications(!showCritFaultNotifications)}
                color={showCritFaultNotifications ? "var(--theme-background)" : "none"}
                fill="var(--input-background)"
                stroke="var(--input-background)"
              />
            </div>
          </Tooltip>

          <Tooltip title={t("Show_Low_Battery_notifications")}>
            <div>
              <BatteryIcon
                onClick={() => setShowBatteryNotifications(!showBatteryNotifications)}
                color={showBatteryNotifications ? "var(--theme-background)" : "none"}
                fill="var(--input-background)"
                stroke="var(--input-background)"
              />
            </div>
          </Tooltip>

          <Tooltip title={t("Show_Max_Holes_notifications")}>
            <div>
              <FilterFlagIcon
                onClick={() => setShowMaxHolesNotifications(!showMaxHolesNotifications)}
                color={showMaxHolesNotifications ? "var(--theme-background)" : "none"}
                fill="var(--input-background)"
                stroke="var(--input-background)"
              />
            </div>
          </Tooltip>

          {enableMemberCar &&
            <Tooltip title={t("Show_member_cars")}>
              <div>
                <MembercarIcon
                  onClick={() => setShowMemberCars(!showMemberCars)}
                  width={30}
                  height={30}
                  bg={showMemberCars ? "transparent" : "var(--theme-background)"}
                  color={showMemberCars ? "var(--input-background)" : "white"}
                  stroke="var(--input-background)"
                />
              </div>
            </Tooltip>
          }

          {(isUserAdmin(getUserRole && getUserRole?.Role) ||
            isUserSupport(getUserRole && getUserRole?.Role)) && (
              <Tooltip title={t("Show_diagnostics_messages")}>
                <div>
                  <DiagnosticsIcon
                    bg={showDiagnostics ? "#4f8edc" : "#b7e0f4"}
                    stroke="#ffffff"
                    color={showDiagnostics ? "white" : "#585757"}
                    onClick={() =>
                      setShowDiagnostics((prev) => !prev)
                    }
                  />
                </div>
              </Tooltip>
            )}
        </div>

        {(isUserAdmin(getUserRole?.Role) ||
          isUserSupport(getUserRole?.Role)) && (
            <div style={{ marginRight: "10px" }}>
              <TextField
                size="small"
                placeholder="Search by text..."
                value={messageTextFilter}
                onChange={(e) =>
                  setMessageTextFilter(e.target.value)
                }
                variant="outlined"
                sx={{
                  width: 170,
                  backgroundColor: "#fff",
                  "& .MuiOutlinedInput-root": {
                    height: "34px",
                    "& fieldset": {
                      borderColor: "#AEAEAe",
                    },
                    "&:hover fieldset": {
                      borderColor: "#9e9e9e",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#9e9e9e",
                    },
                  },
                  borderRadius: 2,
                }}
              />

              <Tooltip
                title={t("Number_of_messages_hidden_by_filters")}
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                }}
              >
                <div className="filter-icon">
                  <FilterAltIcon color="#fff" />
                  <p>{filteredData.filteredCount}</p>
                </div>
              </Tooltip>
            </div>
          )}
      </Header>

      <MobileHeader>
        <h4>History</h4>

        <IconButton>
          <ThreeDotIcon
            color="#fff"
            width={3.19}
            height={14.36}
            onClick={() => setThreeDotState(!threeDotState)}
          />
        </IconButton>

        {threeDotState && (
          <div className="open-section">
            <Header>
              <Tooltip title={t("Filter_by_car_number")}>
                <div>
                  <SearchWrapper>
                    <input
                      type="text"
                      placeholder="Car no."
                      value={searchInputValue}
                      onChange={(e) => setSearchInputValue(e.target.value)}
                    />
                    <img src={SearchIcon} alt="search-icon" />
                  </SearchWrapper>
                </div>
              </Tooltip>

              <DateRangePickerWrapper>
                <p className="label">{t("Start")}</p>

                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    inputFormat="DD-MMM-YYYY"
                    selectsEnd
                    value={startDate}
                    className="test"
                    onChange={(newValue) => { dateChecker(newValue, "startDate"); }}
                    renderInput={(params) => (<TextField {...params} />)}
                  />
                </LocalizationProvider>

                <p className="label">{t("End")}</p>

                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    className="test"
                    inputFormat="DD-MMM-YYYY"
                    value={endDate}
                    onChange={(newValue) => { dateChecker(newValue, "endDate"); }}
                    renderInput={(params) => (<TextField {...params} />)}
                  />
                </LocalizationProvider>
              </DateRangePickerWrapper>

              <Tooltip title={t("Refresh")}>
                <div>
                  <button className="refresh-btn" onClick={refresh}>
                    <ResendIcon />
                  </button>
                </div>
              </Tooltip>

              <div>
                <Tooltip title={t("Show_messages_to_cars")}>
                  <div>
                    <ClubToCarMsgIcon
                      onClick={() => setShowToCar(!showToCar)}
                      backgroundColor="blue"
                      color={showToCar ? "var(--theme-background)" : "var(--input-background)"}
                    />
                  </div>
                </Tooltip>

                <Tooltip title={t("Show_messages_from_cars")}>
                  <div>
                    <CarToClubMsgIcon
                      onClick={() => setShowFromCar(!showFromCar)}
                      color={showFromCar ? "var(--theme-background)" : "var(--input-background)"}
                    />
                  </div>
                </Tooltip>

                <Tooltip title={t("Show_messages_forwarded_to_marshal(s)")}>
                  <div>
                    <CarToMarshalCarMsg
                      onClick={() => setShowForwarded(!showForwarded)}
                      color={showForwarded ? "var(--theme-background)" : "var(--input-background)"}
                    />
                  </div>
                </Tooltip>

                <Tooltip title={t("Group_broadcast_messages_together")}>
                  <div>
                    <CarToAllMsg
                      onClick={() => setShowBroadcast(!showBroadcast)}
                      color={showBroadcast ? "var(--theme-background)" : "var(--input-background)"}
                    />
                  </div>
                </Tooltip>
              </div>

              <div>
                <Tooltip title={t("Show_Action_Zone_notifications")}>
                  <div>
                    <ExclamationMarkTrangel
                      onClick={() => setShowAZNotifications(!showAZNotifications)}
                      color={showAZNotifications ? "var(--theme-background)" : "none"}
                      fill="var(--input-background)"
                      stroke="var(--input-background)"
                    />
                  </div>
                </Tooltip>

                <div>
                  <ExclamationMarkIcon
                    onClick={() => setShowCritFaultNotifications(!showCritFaultNotifications)}
                    color={showCritFaultNotifications ? "var(--theme-background)" : "none"}
                    fill="var(--input-background)"
                    stroke="var(--input-background)"
                  />
                </div>

                <Tooltip title={t("Show_Low_Battery_notifications")}>
                  <div>
                    <BatteryIcon
                      onClick={() => setShowBatteryNotifications(!showBatteryNotifications)}
                      color={showBatteryNotifications ? "var(--theme-background)" : "none"}
                      fill="var(--input-background)"
                      stroke="var(--input-background)"
                    />
                  </div>
                </Tooltip>

                <Tooltip title={t("Show_Max_Holes_notifications")}>
                  <div>
                    <FilterFlagIcon
                      onClick={() => setShowMaxHolesNotifications(!showMaxHolesNotifications)}
                      color={showMaxHolesNotifications ? "var(--theme-background)" : "none"}
                      fill="var(--input-background)"
                      stroke="var(--input-background)"
                    />
                  </div>
                </Tooltip>

                {enableMemberCar && (
                  <Tooltip title={t("Show_member_cars")}>
                    <div>
                      <MembercarIcon
                        onClick={() => setShowMemberCars(!showMemberCars)}
                        width={30}
                        height={30}
                        bg={showMemberCars ? "transparent" : "var(--theme-background)"}
                        color={showMemberCars ? "var(--input-background)" : "white"}
                        stroke="var(--input-background)"
                      />
                    </div>
                  </Tooltip>
                )}
              </div>
            </Header>
          </div>
        )}
      </MobileHeader>

      <TableContainer className="history-table">
        <BodyWrapper>
          <HistoryTableInnerSection className="no-pagination">
            <DataGridPro
              rows={filteredData.rows}
              columns={columns}
              getRowHeight={getRowHeight}
              getRowId={(row) => row?.Id}
              sortingOrder={["asc", "desc"]}
              disableSelectionOnClick
              disableColumnMenu
              hideFooter
              disableVirtualization={false}
              sx={dataGridStyle}
              components={{
                NoRowsOverlay: () => (
                  <Stack height="100%" alignItems="center" justifyContent="center">
                    {t("No_data")}
                  </Stack>
                ),
              }}
            />
          </HistoryTableInnerSection>
        </BodyWrapper>
      </TableContainer>
    </HistoryContainer>
  );
};